module.exports = __webpack_public_path__ + "static/media/devCoding.81178b47.gif";